import React from 'react';
import DriverJobAssignment from './DriverJobAssignment';

export default class DispatchJobStaffAssignments extends React.Component {
    render() {
        const { job, jobIndex, dayInt } = this.props;

        if (
            !job.assignments ||
            !job.assignments[dayInt] ||
            !job.assignments[dayInt].staff ||
            !job.assignments[dayInt].staff.length
        ) {
            return null;
        }

        return (
            <>
                {job.assignments[dayInt].staff.map((group, index) => {
                    const key = `${jobIndex}_${dayInt}_staff_${index}`;
                    return (
                        <DriverJobAssignment
                            key={key}
                            assignmentIndex={index}
                            group={group}
                            {...this.props}
                        />
                    );
                })}
            </>
        );
    }
}
